import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}
interface State {
  error: Error | null
}

/** Keeps a single tool widget crashing from taking down the page. */
export default class ToolErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  render() {
    if (this.state.error) {
      return (
        <div role="alert" className="rounded-2xl border border-red-200 bg-red-50 p-6 text-sm text-red-800">
          <p className="font-semibold m-0">Something went wrong in this tool.</p>
          <p className="mt-1 mb-3">{this.state.error.message}</p>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            className="rounded-full bg-red-100 px-4 py-1.5 font-semibold hover:bg-red-200"
          >
            Try again
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
